import React, { useEffect } from 'react'
import * as UIcons from '@iconscout/react-unicons'
import Btn, { FormBtn } from 'components/Btn'
import { useSelector } from 'react-redux'
import { setFormLoading, getResponse, showModal } from 'store/slices/miscSlice'
import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { apiRequest } from 'store/Misc/apiRequest'
import { toast } from 'react-toastify'
import { yupResolver } from '@hookform/resolvers/yup'
import { withTranslation } from 'react-i18next'
import { destructureErrorMessage } from 'Helper'
import { mutate } from 'swr'

export default withTranslation()(function ModalForm({ t }) {
  const selector = useSelector(state => state.misc)
  const data = selector?.modal?.data
  const state = selector?.modal?.state
  const dispatch = useDispatch()

  const method = useForm({
    mode: 'all',
    resolver: data?.validation ? yupResolver(data?.validation) : ''
  })


  const { handleSubmit, reset, watch, formState: { isDirty, isValid } } = method

  useEffect(() => {
    reset(data?.values)
  }, [reset, data])


  const Component = data?.content

  const close = (error) => {
    const actions = error ? [showModal] : [showModal, setFormLoading]
    actions.map(action => dispatch(action('close')))
  }

  const submit = async (payload) => {
    dispatch(setFormLoading())
    if (data.extraPayload) {
      Object.assign(payload, data.extraPayload)
    }
    try {
      const { data: res } = await apiRequest({
        method: data?.method,
        // action: data?.dispatchAction,
        url: data?.url,
        payload
      })
      dispatch(getResponse(res))

      // console.log('Main dispatch action', data.dispatchAction, 'And result here:', result)
      if (data?.mutate) mutate(data?.mutate ?? data?.url)
      // if (data.method === 'put') dispatch(data.dispatchAction({...payload, id: data.updateId}))
      // else if (data.dispatchAction) dispatch(result.data)

      toast.success(data?.successMsg)
    } catch ({ message }) {
      close(true)
      // console.log('Error message before destructuring', message)
      destructureErrorMessage(message).map(msg => {
        return toast.error(msg, { autoClose: 15000 })
      })
    }

    close()
  }


  return (
    <>
      {
        !state ? (
          <></>
        ) : (
          <div className="fixed w-screen h-screen bg-black bg-opacity-30 flex z-50 left-0 top-0">
            <FormProvider {...method}>
              <form className="w-11/12 md:w-[390px] lg:w-[490px] bg-white rounded-lg m-auto px-5 md:px-10 pb-8 relative" onSubmit={handleSubmit(submit)}>
                <h3 className="text-xl py-5 w-full text-center font-semibold text-secondary">{data?.title} {data?.extra}</h3>

                <UIcons.UilTimes
                  className="absolute top-2 right-3 cursor-pointer"
                  onClick={close}
                />

                <div className="w-full">
                  <Component getValues={watch} />
                </div>

                <div className="w-full md:w-5/6 mt-5 mx-auto grid grid-cols-2 gap-5">
                  <Btn
                    content={t('misc.cancel')}
                    className="w-full h-12 text-primary rounded-xl border border-primary"
                    variant="outlined"
                    click={close}
                  />

                  <FormBtn
                    content={data?.btnText ?? t('misc.submit')}
                    className="w-full h-12 text-white rounded-xl bg-primary hover:bg-primary"
                    disabled={data?.disableBtn ?? (!isValid || !isDirty)}
                  />
                </div>
              </form>
            </FormProvider>
          </div>
        )
      }
    </>
  )
})
